export default __webpack_public_path__ + "static/media/capri2.4b24dc85.png";